import { produce } from "immer";
import {
  //
  ADD_REPLY,
  ADD_REPLY_FAILURE,
  ADD_REPLY_SUCCESS,
  //
  ADD_REVIEWS,
  ADD_REVIEWS_FAILURE,
  ADD_REVIEWS_SUCCESS,
  //
  DELETE_REPLY,
  DELETE_REPLY_FAILURE,
  DELETE_REPLY_SUCCESS,
  TOGGLE_DELETE,
  //
  DELETE_REVIEWS,
  DELETE_REVIEWS_FAILURE,
  DELETE_REVIEWS_SUCCESS,
  //
  EDIT_REPLY,
  EDIT_REPLY_FAILURE,
  EDIT_REPLY_SUCCESS,
  //
  EDIT_REVIEWS,
  EDIT_REVIEWS_FAILURE,
  EDIT_REVIEWS_SUCCESS,
  //
  FETCH_REVIEWS,
  FETCH_REVIEWS_FAILURE,
  FETCH_REVIEWS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  TOGGLE_ASK,
  //
  REQ_REVISE,
  REQ_REVISE_SUCCESS,
  REQ_REVISE_FAILURE,
  //
  TOGGLE_PHOTOS,
  TOGGLE_VIDEOS,
  TOGGLE_RATING,
  //
  SET_IMG_FILTERS,
  //
  GET_IMAGE,
  GET_IMAGE_SUCCESS,
  GET_IMAGE_FAILURE,
  //
  ADD_REVIEW_CARD,
  ADD_REVIEW_CARD_SUCCESS,
  ADD_REVIEW_CARD_FAILURE,
  //
  TOGGLE_PIN_MODAL,
  //
  FETCH_UPLOADS,
  FETCH_UPLOADS_SUCCESS,
  FETCH_UPLOADS_FAILURE,
  //
  TOGGLE_CARD_MODAL,
  TOGGLE_INSTRUCTIONS,
} from "./constants";
import { defaultFilters } from "../../Data/imageGenerator";

export const initialState = {
  isFetchingReviews: false,
  Reviews: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentReviews: {},
  // Delete
  isDeleting: false,
  isAddingReply: false,
  isEditingReply: false,
  isDeletingReply: false,
  deleteModal: { open: false },
  askModal: { open: false },
  isRequesting: false,
  photoModal: { open: false },
  videoModal: { open: false },
  ratingModal: { open: false },
  imageFilters: {
    ...defaultFilters,
  },
  isGeneratingImage: false,
  image: null,
  pinModal: false,
  isAddingCard: false,
  isFetchingUploads: false,
  uploadList: [],
  cardModal: { open: false, data: {} },
  instructionModal: { open: false },
};

const ReviewsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_REVIEWS:
        draft.isFetchingReviews = true;
        draft.currentReviews = {};
        break;
      case FETCH_REVIEWS_SUCCESS:
        draft.isFetchingReviews = false;
        draft.Reviews = action.payload;
        break;
      case FETCH_REVIEWS_FAILURE:
        draft.isFetchingReviews = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentReviews = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentReviews = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_REVIEWS:
        draft.isSubmitting = true;
        break;
      case ADD_REVIEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_REVIEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_REVIEWS:
        draft.isSubmitting = true;
        break;
      case EDIT_REVIEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_REVIEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_REVIEWS:
        draft.isDeleting = true;
        break;
      case DELETE_REVIEWS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_REVIEWS_FAILURE:
        draft.isDeleting = false;
        break;

      case ADD_REPLY:
        draft.isAddingReply = true;
        break;
      case ADD_REPLY_SUCCESS:
        draft.isAddingReply = false;
        break;
      case ADD_REPLY_FAILURE:
        draft.isAddingReply = false;
        break;

      case EDIT_REPLY:
        draft.isEditingReply = true;
        break;
      case EDIT_REPLY_SUCCESS:
        draft.isEditingReply = false;
        break;
      case EDIT_REPLY_FAILURE:
        draft.isEditingReply = false;
        break;

      case DELETE_REPLY:
        draft.isDeletingReply = true;
        break;
      case DELETE_REPLY_SUCCESS:
        draft.isDeletingReply = false;
        break;
      case DELETE_REPLY_FAILURE:
        draft.isDeletingReply = false;
        break;

      case TOGGLE_DELETE:
        draft.deleteModal = action.payload;
        break;
      case TOGGLE_ASK:
        draft.askModal = action.payload;
        break;

      case REQ_REVISE:
        draft.isRequesting = true;
        break;
      case REQ_REVISE_SUCCESS:
        draft.isRequesting = false;
        break;
      case REQ_REVISE_FAILURE:
        draft.isRequesting = false;
        break;

      case TOGGLE_PHOTOS:
        draft.photoModal = action.payload;
        break;
      case TOGGLE_VIDEOS:
        draft.videoModal = action.payload;
        break;
      case TOGGLE_RATING:
        draft.ratingModal = action.payload;
        break;

      case SET_IMG_FILTERS:
        draft.imageFilters = action.payload;
        break;

      case GET_IMAGE:
        draft.isGeneratingImage = true;
        draft.image = null;
        break;
      case GET_IMAGE_SUCCESS:
        draft.isGeneratingImage = false;
        draft.image = action.payload;
        break;
      case GET_IMAGE_FAILURE:
        draft.isGeneratingImage = false;
        draft.image = null;
        break;

      case ADD_REVIEW_CARD:
        draft.isAddingCard = true;
        break;
      case ADD_REVIEW_CARD_SUCCESS:
        draft.isAddingCard = false;
        break;
      case ADD_REVIEW_CARD_FAILURE:
        draft.isAddingCard = false;
        break;

      case FETCH_UPLOADS:
        draft.isFetchingUploads = true;
        draft.uploadList = [];
        break;
      case FETCH_UPLOADS_SUCCESS:
        draft.isFetchingUploads = false;
        draft.uploadList = action.payload;
        break;
      case FETCH_UPLOADS_FAILURE:
        draft.isFetchingUploads = false;
        draft.uploadList = [];
        break;

      case TOGGLE_PIN_MODAL:
        draft.pinModal = action.payload;
        break;

      case TOGGLE_CARD_MODAL:
        draft.cardModal = action.payload;
        break;

      case TOGGLE_INSTRUCTIONS:
        draft.instructionModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default ReviewsReducer;
